export default __webpack_public_path__ + "static/media/icon.powerbanks.fc2c7c01.svg";